<template>
  <div id="app"> 
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data:()=>({

  }),
}
</script>

<style lang="scss"> 
  html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    border: 0;
    padding: 0;
  }

  * {
    font-family: 'Poppins', sans-serif;
  }

  #app {
    position: relative;
    display: flex;
    justify-content: center; 
  }

  
  
</style>
